// extracted by mini-css-extract-plugin
export default {"button_icon__rotated":"assets-container_button_icon__rotated__iI0JO"};